import { datadogRum } from '@datadog/browser-rum';

import { Environment } from '@cobliteam/react-environments';

export * from './DatadogTrack';

const env = Environment.getInstance().getEnvironment();

export const DEFAULT_ALLOWED_TRACING_URLS = ['https://api.cobli.co', 'https://api-beta.cobli.co'];

export default ({ configuration, user }: { configuration: any; user: any }) => {
  const { ddRUMapplicationId, ddRUMclientToken } = env;

  if (!(ddRUMapplicationId && ddRUMclientToken)) {
    console.warn('Datadog RUM AppID and/or Client Token was not found in the ENV vars!');
    return;
  }
  datadogRum.init({
    ...configuration,
    applicationId: ddRUMapplicationId,
    clientToken: ddRUMclientToken,
    site: 'datadoghq.com',
    silentMultipleInit: true,
    overrideAllowedTracingOrigins: DEFAULT_ALLOWED_TRACING_URLS,
  });
  datadogRum.setUser(user);
  datadogRum.startSessionReplayRecording();
};
